export enum adminRecommendApplicantsTypes {
    FETCH_ADMIN_RECOMMEND_APPLICANTS_SUCCESS = "FETCH_ADMIN_RECOMMEND_APPLICANTS_SUCCESS",
    FETCH_ADMIN_RECOMMEND_APPLICANTS_REQUEST = "FETCH_ADMIN_RECOMMEND_APPLICANTS_REQUEST",
    FETCH_ADMIN_RECOMMEND_APPLICANTS_FAILURE = "FETCH_ADMIN_RECOMMEND_APPLICANTS_FAILURE",

}